<template>
  <div v-if="props.showMessage" class="app-alert-warning"
       role="alert" aria-live="off"><!-- no feedback if user has opt-out -->
    <img src="@ridmv/web-themes/images/icons/exclamation-triangle-solid.svg" alt="">
    <p tabindex="-1" ref="message" class="animate__animated animate__headShake">
      {{ feedback.message }}
    </p>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue';
import SystemFeedback from '@/assets/data/_systemFeedback';

// Props 
const props = defineProps({
  showMessage: {
    type: Boolean,
    required: false,
    default: false,      // prevent display on reload
  },
});

// State and Reactive Variables
const feedback = ref({});

// Template Ref 
const message = ref(null);

// Methods 
const getFeedback = () => {
  return SystemFeedback.find(fbk => fbk.errorType === 'cxlRes');
};

const setupMessage = async () => {
  feedback.value = getFeedback();
  await nextTick();
  if (message.value) {
    message.value.focus();
  }
};

// Lifecycle Hook 
onMounted(() => {
  setupMessage();
});
</script>


<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/system-alert";
</style>
